// jarvis-cleanup: режимы беседы Buddy отключены — компонент ничего не показывает
import type { BuddyMode } from "./api"

export function BuddyModeSelect(_props: { sessionId: string; initial: BuddyMode }) {
  return null
}
